import { render, staticRenderFns } from "./communityUser.vue?vue&type=template&id=427624c2&scoped=true&"
import script from "./communityUser.vue?vue&type=script&lang=js&"
export * from "./communityUser.vue?vue&type=script&lang=js&"
import style0 from "./communityUser.vue?vue&type=style&index=0&id=427624c2&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "427624c2",
  null
  
)

export default component.exports